import React from 'react';
import { InputField } from '../../../../healtheraComponents';
import { StyledFormContainer, StyledPaperContainer, StyledSectionTitle } from '../../PlusWebsiteEditor.styles';
import { StyledImageUploader } from './SeoSection.styled';
import { WebsiteConfiguration } from '../../types/websiteConfiguration';
import { SectionHandlers, SetFieldValue } from '../../types/handlers';

type Props = WebsiteConfiguration['meta'] &
  SectionHandlers & {
    onChange: SetFieldValue<string>;
  };

const SeoSection = (props: Props) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => props.onChange(e.target.name, e.target.value);

  return (
    <StyledPaperContainer>
      <StyledSectionTitle>SEO</StyledSectionTitle>
      <StyledFormContainer>
        <InputField helperText={props.getError('title')} onBlur={props.onBlur} onChange={handleInputChange} name="title" label="Page title" margintop="5px" value={props.title} />
        <InputField
          helperText={props.getError('description')}
          onBlur={props.onBlur}
          multiline
          onChange={handleInputChange}
          name="description"
          label="Meta description"
          margintop="5px"
          value={props.description}
        />
        <InputField
          helperText={props.getError('og:title')}
          onBlur={props.onBlur}
          onChange={handleInputChange}
          name="og:title"
          label="Page title in social media page link share (og:title)"
          margintop="5px"
          value={props['og:title']}
        />
        <InputField
          helperText={props.getError('og:description')}
          onBlur={props.onBlur}
          multiline
          onChange={handleInputChange}
          name="og:description"
          label="Description in social media page link share (og:description)"
          margintop="5px"
          value={props['og:description']}
        />
        <StyledImageUploader
          helperText={props.getError('image')}
          title="Image in social media (og:image)"
          url={props.image || props['og:image'] || ''}
          onChange={(base64: string) => props.onChange('image', base64, true)}
        />
      </StyledFormContainer>
    </StyledPaperContainer>
  );
};

export default SeoSection;
